import { render, staticRenderFns } from "./index.vue?vue&type=template&id=192f167b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192f167b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('192f167b')) {
      api.createRecord('192f167b', component.options)
    } else {
      api.reload('192f167b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=192f167b&scoped=true&", function () {
      api.rerender('192f167b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/activeYear/index.vue"
export default component.exports